import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MultiSelectComponent } from './multiselect.component';
import { ClickOutsideDirective } from './click-outside.directive';
import { ListFilterPipe } from './list-filter.pipe';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslationLoaderFactory } from '@monorepo/services';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          const factory = new TranslationLoaderFactory(http);
          return factory.createForApp('oi-app');
        },
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [MultiSelectComponent, ClickOutsideDirective, ListFilterPipe],
  exports: [MultiSelectComponent],
})
export class NgMultiSelectDropDownModule {
  static forRoot(): ModuleWithProviders<NgMultiSelectDropDownModule> {
    return {
      ngModule: NgMultiSelectDropDownModule,
    };
  }
}
